import type { IResource, OfficeWithFloors } from "@gettactic/api";

interface DivisionCategories {
  offices: Record<string, OfficeWithFloors>;
}

interface OfficeLookupParams {
  officeId?: string | null;
  parentId?: string | null;
  divisionCategories?: DivisionCategories;
  userOfficesById?: Record<
    string,
    {
      name?: string | null;
      time_zone?: string | null;
    }
  >;
}

export function getOfficeAndFloor({
  officeId,
  parentId,
  divisionCategories,
  userOfficesById
}: OfficeLookupParams) {
  let office:
    | OfficeWithFloors
    | {
        name?: string | null;
        time_zone?: string | null;
      }
    | undefined;

  if (officeId && divisionCategories) {
    office = divisionCategories.offices[officeId];
  } else if (officeId && userOfficesById) {
    office = userOfficesById[officeId];
  }

  let officeWithFloors: OfficeWithFloors | undefined;
  if (officeId && divisionCategories) {
    officeWithFloors = divisionCategories.offices[officeId];
  }

  const floor = officeWithFloors?.floors?.find(
    (floor: IResource) => floor.id === parentId
  );

  const officeName = office?.name || "";
  const floorName = floor?.name || "";

  return {
    office,
    officeWithFloors,
    floor,
    officeName,
    floorName
  };
}
